import { fieldComponents } from "../fields";
import { FeedbackChangeHandler, FeedbackData } from "../fields/fields.types";
import { FeedbackField } from "../types/feedback.types";

export type FormErrors = Record<string, boolean>;

type FieldProps = {
  field: FeedbackField;
  data: FeedbackData;
  error: boolean | undefined;
  onChange: FeedbackChangeHandler;
};

const Field = ({ field, data, error, onChange }: FieldProps): JSX.Element | null => {
  const Component = fieldComponents[field.type];

  if (!Component) {
    console.error("Missing component for", field.type, field);
    return null;
  }

  return <Component field={field} data={data} error={error} onChange={onChange} />;
};

export default Field;
